module.exports = __webpack_public_path__ + "img/view-rain-animation-2.988a429a.png";